module.exports = ".menu-items li:first-child {\n    margin-top:10px\n}"